import type { MarkdownBuffer, MarkdownBufferActionGroup } from './types';

export default function createMarkdownBuffer(): MarkdownBuffer {
  const markdownLinesPerActionPublicId: Record<string, MarkdownBufferActionGroup> = {};

  return {
    append: entry => {
      const arr = Array.isArray(entry) ? entry : [entry];
      arr.forEach(entryToAppend => {
        const {
          actionPublicId,
          line,
          isNested = false,
        } = entryToAppend;
        if (!Object.hasOwn(markdownLinesPerActionPublicId, actionPublicId)) {
          markdownLinesPerActionPublicId[actionPublicId] = {
            lines: [],
            isNested,
          };
        }

        markdownLinesPerActionPublicId[actionPublicId].lines.push(line);
      });
    },
    package: () => Object
      .values(markdownLinesPerActionPublicId)
      .map(({ lines, isNested }) => {
        const indented = isNested
          ? lines.map(l => `\t${l}`)
          : lines;
        return indented.join('\n');
      })
      .join('\n\n'),
  };
}
